export const token = (state) => state.token;

export const participantById = (state) => (id) => state.allParticipants.find((p) => +p.id === +id);

export const isPendingParticipant = (state) => (id) => state.pendingParticipantIds.find((pId) => +pId === +id);
